import { apiClient } from '@/services/ApiClient.js'

export default {
  getBaseInterestRates(query) {
    return apiClient
      .get('base-interest-rates', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBaseInterestRate(id) {
    return apiClient
      .get('base-interest-rates/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createBaseInterestRate(baseInterestRate) {
    return apiClient
      .post('base-interest-rates', baseInterestRate)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  startImportProcess(form) {
    let formData = new FormData()
    formData.append('file', form.file)

    return apiClient
      .postForm('/base-interest-rates/import', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadImageForPriceComparison(form) {
    let formData = new FormData()
    formData.append('file', form.file)
    formData.append('isActiveInterestRateImage', form.isActiveInterestRateImage)

    return apiClient
      .postForm('/base-interest-rates/upload-image-for-price-comparison', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  removePriceComparisonImage() {
    return apiClient
      .post('/base-interest-rates/remove-price-comparison-image')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getInterestRateImageSettings() {
    return apiClient
      .get('/base-interest-rates/get-price-comparison-image-settings')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
